module.exports = __webpack_public_path__ + "static/media/cloud-sun.a46aa2b4.svg";